import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.string.includes.js";
import { filterVAutocomplete } from "@/js/forms.js";
import { stockReservationTypes } from "@/js/lists.ts";
import { formRules } from "@/js/form_rules.js";
import StockReservation from "@/components/stock/StockReservation.vue";
export default {
  name: "PurchaseOrderItemsReservationTable",
  components: {
    StockReservation: StockReservation
  },
  props: {
    parentItem: {},
    userList: [],
    consultantList: [],
    disabled: Boolean
  },
  data: function data(_this) {
    return {
      headers: [{
        text: "Reservation",
        value: "reservation"
      }, {
        text: "Quantity",
        value: "quantity"
      }, {
        text: "Actions",
        value: "actions"
      }],
      form: {
        valid: false
      },
      dialog: false,
      dialogDelete: false,
      editedItem: {
        id: 0,
        type: null,
        userId: "",
        consultantId: "",
        quantity: 0
      },
      defaultItem: {},
      rules: formRules
    };
  },
  created: function created() {
    this.defaultItem = _objectSpread({}, this.editedItem);
    this.selectedItems = _toConsumableArray(this.parentItem.reservations);
  },
  computed: {
    formTitle: function formTitle() {
      return this.editedItem.id ? "Edit order quantity" : "Add order quantity";
    },
    usersStillReservable: function usersStillReservable() {
      var _this2 = this;
      var usersIdAlreadyUsed = this.parentItem.reservations.filter(function (x) {
        return x.type == stockReservationTypes.SPECIFIC_CUSTOMER.id;
      }).map(function (x) {
        return x.userId;
      });
      return this.userList.filter(function (x) {
        return !usersIdAlreadyUsed.includes(x.id) || x.id == _this2.editedItem.userId;
      });
    },
    consultantsStillReservable: function consultantsStillReservable() {
      var _this3 = this;
      var consultantsIdAlreadyUsed = this.parentItem.reservations.filter(function (x) {
        return x.type == stockReservationTypes.SPECIFIC_CONSULTANT.id;
      }).map(function (x) {
        return x.consultantId;
      });
      return this.consultantList.filter(function (x) {
        return !consultantsIdAlreadyUsed.includes(x.id) || x.id == _this3.editedItem.consultantId;
      });
    },
    maxAllowed: function maxAllowed() {
      var _this4 = this;
      var maxAllowed = this.parentItem.quantity;
      var alreadyDispatchOnOrders = +this.parentItem.quantitiesForOrders.reduce(function (acc, x) {
        return acc + x.quantity;
      }, 0);
      var alreadyDispatchOnReservations = this.parentItem.reservations.reduce(function (acc, x) {
        if (_this4.editedItem.type == x.type && x.userId == _this4.editedItem.userId) {
          return acc;
        } else if (_this4.editedItem.type == x.type && x.consultantId == _this4.editedItem.consultantId) {
          return acc;
        } else {
          return acc + +x.quantity;
        }
      }, 0);
      maxAllowed -= alreadyDispatchOnOrders + alreadyDispatchOnReservations;
      return maxAllowed;
    },
    excludedStockReservationTypeIds: function excludedStockReservationTypeIds() {
      var array = [stockReservationTypes.DEFAULT.id];
      if (this.parentItem.reservations.length > 0 && !this.editedItem.isBeingEdited) {
        array = [].concat(_toConsumableArray(array), _toConsumableArray(this.parentItem.reservations.filter(function (x) {
          return x.type !== stockReservationTypes.SPECIFIC_CUSTOMER.id && x.type !== stockReservationTypes.SPECIFIC_CONSULTANT.id;
        }).map(function (x) {
          return x.type;
        })));
      }
      return array;
    }
  },
  methods: {
    updateStockReservation: function updateStockReservation(form) {
      this.editedItem.type = form.stockReservationType;
      this.editedItem.userId = form.stockReservationUserId;
      this.editedItem.consultantId = form.stockReservationConsultantId;
    },
    changeQuantity: function changeQuantity(value) {
      if (+value > this.maxAllowed) {
        this.editedItem.quantity = this.maxAllowed;
        this.$toasted.show("There is not enough quantity available", {
          type: "warning"
        });
      }
    },
    editItem: function editItem(item) {
      this.editedItem = _objectSpread(_objectSpread({}, item), {}, {
        isBeingEdited: true,
        editedIndex: this.selectedItems.findIndex(function (x) {
          return x.type === item.type && x.userId === item.userId && x.consultantId === item.consultantId;
        })
      });
      this.dialog = true;
    },
    deleteItem: function deleteItem(item) {
      this.editedItem = item;
      this.dialogDelete = true;
    },
    deleteItemConfirm: function deleteItemConfirm() {
      this.selectedItems.splice(this.selectedItems.indexOf(this.editedItem), 1);
      this.closeDelete();
      this.$emit("save", this.selectedItems);
    },
    close: function close() {
      var _this5 = this;
      this.dialog = false;
      this.$nextTick(function () {
        _this5.editedItem = _objectSpread({}, _this5.defaultItem);
      });
    },
    closeDelete: function closeDelete() {
      var _this6 = this;
      this.dialogDelete = false;
      this.$nextTick(function () {
        _this6.editedItem = _objectSpread({}, _this6.defaultItem);
      });
    },
    save: function save() {
      var editedIndex = this.editedItem.editedIndex;
      if (this.editedItem.editedIndex > -1) {
        if (this.editedItem.isBeingEdited) {
          this.selectedItems.splice(editedIndex, 1, _objectSpread({}, this.editedItem));
        } else {
          this.selectedItems.splice(editedIndex, 1, _objectSpread({}, this.editedItem));
        }
      } else {
        this.selectedItems = [].concat(_toConsumableArray(this.selectedItems), [_objectSpread({}, this.editedItem)]);
      }
      this.close();
      this.editedItem = _objectSpread({}, this.defaultItem);
      this.$emit("save", this.selectedItems);
    },
    getLabelReservation: function getLabelReservation(item) {
      if (item.type === stockReservationTypes.SPECIFIC_CUSTOMER.id) {
        if (!!this.userList.length) {
          var _this$userList$find;
          return (_this$userList$find = this.userList.find(function (x) {
            return x.id_user === item.userId;
          })) === null || _this$userList$find === void 0 ? void 0 : _this$userList$find.full_name;
        } else {
          return "(loading user details)";
        }
      } else if (item.type === stockReservationTypes.SPECIFIC_CONSULTANT.id) {
        if (!!this.consultantList.length) {
          var _this$consultantList$;
          return (_this$consultantList$ = this.consultantList.find(function (x) {
            return x.id_user === item.consultantId;
          })) === null || _this$consultantList$ === void 0 ? void 0 : _this$consultantList$.full_name;
        } else {
          return "(loading user details)";
        }
      } else {
        return Object.values(stockReservationTypes).find(function (x) {
          return x.id === item.type;
        }).name;
      }
    },
    filterVAutocomplete: filterVAutocomplete
  },
  watch: {
    dialog: function dialog(val) {
      val || this.close();
    },
    dialogDelete: function dialogDelete(val) {
      val || this.closeDelete();
    }
  }
};